<template>

  <div id="datadetail">
    <div>
        <div class="large-12 medium-12 small-12 columns"><p></p>
          <h2>{{ dataTitle }}</h2>
          <hr> </div>
            <div class="large-12 medium-12 small-12 columns" v-if="baseView.addInfo">
                <label v-html="fromTpl.title"></label>
                <hr>
                <p v-html="fromTpl.description"></p>
                <p v-html="fromTpl.priceRead"></p>
                <a class="actions action" v-html="fromTpl.btnText" v-on:click="callAction()"></a>                        
            </div>
            <div class="large-12 medium-12 small-12 columns" v-if="baseView.addTYPage">

              <p v-html="baseView.TYText"  v-bind:class="{ mActive: baseView.TYInfoAlert }"></p>
                <a class="actions action" onclick="location.reload()" v-if="baseView.TYBtn">Návrat na prehľad</a>
            </div>
        </div>      
       </div>
</template>

<script>
import moment from 'moment'
import Datainfo from '@/components/datainfo'

export default {
  name: 'detail',
  props: ['productdetail', 'tplData', 'states'],
  components: {
    Datainfo
  },
  data () {
    return {
      msg: 'Kreditaction',
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      fromTpl: {

      },
      baseView: {
        add200: false, pBar: true, pgPercentage: 0, pgVal: '', addToGiga: false, stopProlong: false, pgLeftText: "Internet", prolState: "zapnuté",
        prolVisible: false, bucketRest: "0 MB", hasMoreData: false, nextPacks: [], addTextGiga: "Dokúpiť 500 MB za 1 €", addInfo: false, addTYPage: false, TYBtn: false, TYText: '', TYInfoAlert: false
      },
      namesMap: {"GIGA1W":"Raz Giga", "GIGA1M":"Vždy Giga", "GIGA2":"Vždy 2 Giga", "StreamOn Data Unlmtd":"Stream On", "StreamOn Data 200":"Stream On 200 MB", "GIGA6":"Dáta na rok 6GB", "GIGA24":"Dáta na rok 24GB", "GIGADEN":"Giga Deň",
      "SW Data":"Dáta pre blízkych", "Darované dáta z Magenta 1":"", "Promo Data":"Daruj a dostaneš", "GIGAZIMNY":"Giga akcia", "GIGA3":"Vždy Giga (1,5 + 1,5 GB)", "GIGA5":"Vždy 2 Giga (2,5 + 2,5 GB)"
      },
      moment: moment
    }
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.mainView = true 
    that.states.creditActionView = false
    }

    this.states.mainView = false, this.states.datainfoView = false, this.states.datadetailView = false
  },
  mounted: function() {
    var prepComm = this.getActionSet(this.states.creditAction)
    if  (this.states.creditAction.type === "add") {
      this.baseView.addInfo = true
      switch(prepComm.commandType) {
        case 'DC1000':
              this.fromTpl = this.tplData.credit.addonAction.t300Add
              this.fromTpl.dlPrice = 1
          break
        case 'DC500':
              this.fromTpl = this.tplData.credit.addonAction.surf1Add
              this.fromTpl.dlPrice = 1
          break
        case 'ESTE500':
              this.fromTpl = this.tplData.credit.addonAction.gigaMonthAdd
              this.fromTpl.dlPrice = 1
          break
        case 'ESTEGIGA':
              this.fromTpl = this.tplData.credit.addonAction.gigaMoreMonths
              this.fromTpl.dlPrice = 3
          break
      }
    } else {
       this.callAction()
    }
    
  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    },
    dataTitle: function() {
      var res = this.states.creditAction.command
      if (this.states.creditAction.command == "DC500") {
        res = "1,5 GB NAVYŠE"
      } else if(this.states.creditAction.command == "DC1000") {
        res = "3 GB NAVYŠE"
      } else if(this.states.creditAction.command == "FnF") {
        res = "Bezplatné hovory na 0" + String(this.states.creditAction.fnfExt).substring(3)
      } else if(this.states.creditAction.command == "ActivateFVO") {
        res = "Neobmedzené Telekom volania"
      } else if(this.states.creditAction.command == "ActivateFSS") {
        res = "Neobmedzené SMS"
      } else if(this.states.creditAction.command == "ActivateMENU2") {
        res = "Mixi ponuka"
      } else if(this.states.creditAction.command == "ActivateMENU") {
        res = "Mixi ponuka"
      } else {
        res = this.pkgNameRead(res)
      }
      return res.toUpperCase()
    },
    isProd: function() {
      if ((window.location.hostname == "m.telekom.sk") && (this.$store.state.activeAnalytic)) {
        return true
      } else {
        return false
      }
    }
  }, 
  methods: {
    callAction: function() {
      var that = this
      var ext2 = "mweb"
      if (this.states.creditAction.command === "FnF") {
        ext2 = (this.states.creditAction.fnfExt).toString()
      }
      var prepComm = this.getActionSet(this.states.creditAction)
      this.baseView.addTYPage = true, this.baseView.addInfo = false, this.baseView.TYText = this.tplData.credit.httpCallWait, this.baseView.TYInfoAlert = false;
      this.$http.put('/pb/easy-api/packages', { name: prepComm.commandName, ext:[prepComm.commandType, ext2] })
        .then(function (resp) {
            that.baseView.TYText = that.tplData.credit.httpCallSuccess
            that.$store.dispatch('refreshProductDetail')

            if ((that.states.creditAction.type == 'add') && (that.isProd)) {
              var dlName = prepComm.commandName + '_' + prepComm.commandType
              dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': new Date().getTime().toString(), 
                      'affiliation': 'm.telekom',
                      'revenue': that.fromTpl.dlPrice || 0.5
                    },
                    'products': [{
                      'name': dlName,  
                      'id': 'SC0000',
                      'price': that.fromTpl.dlPrice || 0.5,
                      'brand': 'm.telekom',
                      'category': 'VAS',
                      'quantity': 1
                    }]
                  }
                }
              });                 
            }
        })
        .catch(function(error){
          var resText = that.tplData.credit.httpCallFail
          if (error.response.status === 403 && location.hostname !== 'localhost') {
            window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
          } else {
            that.baseView.TYInfoAlert = true
            try {
                if ((error.response.data.message).indexOf('NOK-Insufficient credit') != -1) {
                    resText = 'Požiadavka nebola zrealizovaná pre nedostatočnú výšku kreditu. Skúste znovu po dobití kreditu.'
                }
                if ((error.response.data.message).indexOf('NOK-not allowed') != -1) {
                    resText = 'Ľutujeme, uskutočnenie požiadavky nieje možné. Aktiváciu môžete vykonať až po skončení platnosti aktuálne využívaného balíka.'
                }
                if ((error.response.data.message).toLowerCase().indexOf('no response from') != -1) {
                    that.baseView.TYInfoAlert = false
                    resText = "Požiadavka bola odoslaná, výsledok spracovania potvrdíme SMS správou."
                }
            }
            catch(e) {}
            that.baseView.TYText = resText
          }
        })
        .finally(function() {
          that.baseView.TYBtn = true
        })
    },
      pkgNameRead: function(orig) {
        var res = orig;
        if ((/30d_1gb/i).test(orig)) {
          res = "30D_1GB"
        }
        if ((/30d_3gb/i).test(orig)) {
          res = "30D_3GB"
        }
        if ((/30d_4gb/i).test(orig)) {
          res = "30D_4GB"
        }
        if ((/30d_5gb/i).test(orig)) {
          res = "30D_5GB"
        }
        if ((/30d_6gb(?!x)/i).test(orig)) {
          res = "30D_6GB"
        }
        if ((/30d_6gbx/i).test(orig)) {
          res = "30D_6GBx"
        }
        if ((/30d_10gb/i).test(orig)) {
          res = "30D_10GB"
        }
        if ((/10d_chat/i).test(orig)) {
          res = "10D_CHAT"
        }
        if ((/10d_social/i).test(orig)) {
          res = "10D_SOCIAL"
        }
        if ((/10d_1gb/i).test(orig)) {
          res = "10D_1GB"
        }
        if ((/10d_unltd/i).test(orig)) {
          res = "10D_UnLtd"
        }
        if ((/freecalls21/i).test(orig)) {
          res = "FreeCalls21N"
        }
        if ((/giga24/i).test(orig)) {
          res = "GIGA24"
        }
        if ((/giga6/i).test(orig)) {
          res = "GIGA6"
        }
        if ((/giga2(?!4)/i).test(orig)) {
          res = "GIGA2"
        }
        if ((/giga1(?!w)/i).test(orig)) {
          res = "GIGA1M"
        }
        if ((/giga1w/i).test(orig)) {
          res = "GIGA1W"
        }
        if ((/giga4/i).test(orig)) {
          res = "GIGA4"
        }
        if ((/giga3/i).test(orig)) {
          res = "GIGA3"
        }
        if ((/giga5/i).test(orig)) {
          res = "GIGA5"
        }
        return this.$store.state.namesMap[res] || res
      },
      getActionSet: function(creditAction) {
        var commandName = "ActivateGIGA", commandType = "ESTE500"
        if (creditAction.command === "DC500" || creditAction.command === "DC1000") {
          commandType = creditAction.command
          commandName = "ActivateTpkg"
        }
        if (creditAction.type == "stop") {
          if ((/30d_1gb/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_1GBVYP"            
          }
          if ((/30d_2gb/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_2GBxVYP"
          }
          if ((/30d_3gb/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_3GBVYP"
          }
          if ((/30d_4gb/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_4GBVYP"
          }
          if ((/30d_5gb/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_5GBVYP"
          }
          if ((/30d_6gb(?!x)/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_6GBVYP"
          }
          if ((/30d_6gbx/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_6GBxVYP"
          }
          if ((/30d_10gb(?!x)/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_10GBVYP"
          }
          if ((/30d_10gbx/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "30D_10GBxVYP"
          }
          if ((/10d_unltd/i).test(creditAction.command)) {
            commandName = "ActivateTpkg"
            commandType = "10D_UnLtdVYP"
          }
          if ((/ActivateMENU/i).test(creditAction.command)) {
            commandName = creditAction.command;
            commandType = this.states.creditAction.cGroup
          }
          if (creditAction.command === "FnF") {
            commandType = "0"
            commandName = "FreeCalls21N"
          }
        } 
        if ((/giga2(?!4)|giga1(?!w)|giga3|giga5/i).test(creditAction.command)) {
          if (creditAction.type == "add") {
            commandType = "ESTE500"
          } else {
            commandType = "GIGAVYP"
            if ((/giga2(?!4)/i).test(creditAction.command)) {
              commandType = "2GIGAVYP"
            }
            if ((/giga3/i).test(creditAction.command)) {
              commandType = "GIGA3VYP"
            }
            if ((/giga5/i).test(creditAction.command)) {
              commandType = "GIGA5VYP"
            }
          }
        }
        if (creditAction.command === "ESTE200") {
          commandType = creditAction.command
        }
        if ((/giga6|giga24/i).test(creditAction.command) && (creditAction.type === "add")) {
          commandType = "ESTEGIGA"
        }      
        if ((creditAction.command === "ActivateFSS") || (creditAction.command === "ActivateFVO")) {
          commandName = creditAction.command
          commandType = "2"
        }
      return {commandName: commandName, commandType: commandType}
      }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

</style>
